
import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {IServiceProvider} from "@/model/Service/serviceProviderInterfaces";
import {IErrors} from "@/model/IErrors";

@Component({})
export default class SPIncludedExcluded extends Vue {

  @Prop()
  protected provider!: IServiceProvider;
  @Prop()
  protected errors!: IErrors;
  @Prop()
  protected editing!: boolean;
  @Prop()
  protected viewing!: boolean;

  protected tab: any = null;
  protected localViewing: boolean = false;

  // Initialize properties when the component is mounted
  protected mounted() {
    this.initializeServiceFields();
  }

  protected initializeServiceFields() {
    // If service_includes is not an object, initialize it
    if (typeof this.provider.service_includes !== 'object' || this.provider.service_includes === null) {
      this.$set(this.provider, 'service_includes', {});
    }

    // If service_excludes is not an object, initialize it
    if (typeof this.provider.service_excludes !== 'object' || this.provider.service_excludes === null) {
      this.$set(this.provider, 'service_excludes', {});
    }

    // Initialize language keys based on about_us
    const locales = Object.keys(this.provider.about_us || {});
    locales.forEach(locale => {
      if (!this.provider.service_includes[locale]) {
        this.$set(this.provider.service_includes, locale, '');
      }
      if (!this.provider.service_excludes[locale]) {
        this.$set(this.provider.service_excludes, locale, '');
      }
    });
  }

  protected get hasAnyIncludes(): boolean {
    return this.checkIfTextExists(this.provider.service_includes);
  }

  protected get hasAnyExcludes(): boolean {
    return this.checkIfTextExists(this.provider.service_excludes);
  }

  protected get hasAnyIncludesOrExcludes(): boolean {
    return this.hasAnyIncludes || this.hasAnyExcludes;
  }

  protected get showDetails(): boolean {
    return this.editing || this.viewing || this.localViewing;
  }

  protected onExpand() {
    this.localViewing = true;
  }

  protected checkIfTextExists(textObject: any) {
    if (!textObject || typeof textObject !== 'object') return false;
    return Object.values(textObject).some(value => !!value);
  }

  protected get localeItems(): string[] {
    return Object.keys(this.provider.about_us || {});
  }
}
